import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Listbox from '@/components/Listbox';

import { TOptionItem, withSelectedOptions } from './active-options';
import { OptionsFooter } from './OptionsFooter';

type ActiveOptionsListboxProps = {
  isDark?: boolean;
  active: TOptionItem[];
  resolvedSelected: TOptionItem[];
  isFetching: boolean;
  isError: boolean;
  selected: string[];
  onChange: (next: string[]) => void;
  onClose?: () => void;
};

/** A flat, locally searched list of the active options plus the selection they lack. */
export function ActiveOptionsListbox({
  isDark,
  active,
  resolvedSelected,
  isFetching,
  isError,
  selected,
  onChange,
  onClose,
}: ActiveOptionsListboxProps) {
  const { t } = useTranslation();

  const items = useMemo(
    () => withSelectedOptions(active, selected, resolvedSelected, t('(no disponible)')),
    [active, selected, resolvedSelected, t]
  );

  return (
    <Listbox
      dark={isDark}
      mode="multiple"
      items={items}
      onChange={onChange}
      identifiers={{
        key: 'value',
        value: 'value',
        label: 'label',
        children: 'options',
        image: 'image',
      }}
      selected={selected}
      onClose={onClose}
      noSort
      listFooter={
        <OptionsFooter
          isDark={isDark}
          isFetching={isFetching}
          isError={isError}
          isEmpty={active.length === 0}
        />
      }
    />
  );
}
